import { FC, PropsWithChildren } from "react";

const Hidden: FC<PropsWithChildren> = ({ children }) => {
  if (process.env.REACT_APP_SHOW_HIDDEN_COMPONENTS) {
    return <>{children}</>;
  }
  return null;
};

export default Hidden;
